import { render, staticRenderFns } from "./ReducedСommissions.vue?vue&type=template&id=b83ef400&scoped=true"
import script from "./ReducedСommissions.vue?vue&type=script&lang=js"
export * from "./ReducedСommissions.vue?vue&type=script&lang=js"
import style0 from "./ReducedСommissions.vue?vue&type=style&index=0&id=b83ef400&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83ef400",
  null
  
)

export default component.exports